<mat-dialog-content>
  <div class="w-100">

    <div class="fs-4 text-black mb-4 fw-bold">Select Buzzer</div>

    <hr class="my-3">

    <div class="d-flex flex-column">
      <div class="d-flex justify-content-center align-content-around mb-2">
        <div class="container">
          <div *ngFor="let row of chunkedBuzzerPresets">
            <div class="row mb-2">
              <div class="col" *ngFor="let item of row">
                <button
                  class="border-0 border-gray-500 rounded p-2 py-4 me-2 w-100 fs-5"
                  [ngClass]="{'bg-primary text-white': selectedBuzzerIndex === buzzerPresets.indexOf(item)}"
                  (click)="selectBuzzer(item, buzzerPresets.indexOf(item))">{{ item }}
                </button>
              </div>
            </div>
          </div>
        </div>

      </div>


    </div>
    <hr class="my-3">

  </div>

</mat-dialog-content>

<mat-dialog-actions>
  <div class="d-flex justify-content-center w-100 p-3">
    <div class="col-4 me-3">
      <button class="btn btn-default border-0 fw-semibold mb-0 d-block py-3 w-100" mat-dialog-close="">
        <i class="fa fa-times-circle me-2"></i>
        <span>Cancel</span>
      </button>
    </div>
    <div class="col-8" role="button" (click)="submit()">
      <button
        class="btn btn-default bg-primary text-white w-100 h-100 d-flex align-items-center justify-content-center">
        <i class="fa fa-check-circle me-2"></i>
        <span>Apply Buzzer</span>
      </button>
    </div>
  </div>
</mat-dialog-actions>
